import * as barrage from "./utils/barrage";

class Select {
  /**
   * 連打防止
   */
  barragePreventAll() {
    barrage.prevent("#form_select");
    barrage.prevent("#alert-load");
  }

  /**
   * 背景画像カテゴリ切り替え
   * 背景画像カテゴリ > 背景画像種別
   * NOTE：現状選択領域なし
   */
  toggleBaseillustCategory(categoryId) {
    // 背景画像カテゴリ選択装飾切り替え
    $(".base-iilust-category-list__item.is-select").removeClass("is-select");
    $("#base-iilust-category-list__item-" + categoryId).addClass("is-select");

    // メンバーリスト切り替え
    $(".baseillust-type-list.is-visible").removeClass("is-visible");
    $("#baseillust-type-list-" + categoryId).addClass("is-visible");

    // 最初のを選択
    const firstBaseillustType = $(
      "#baseillust-type-list-" +
        categoryId +
        " .baseillust-type-list__item:first-child"
    ).val();
    this.toggleBaseillustType(firstBaseillustType);
  }

  /**
   * 背景画像種別の切り替え
   * 背景画像カテゴリ > 背景画像種別
   */
  toggleBaseillustType(baseillustType) {
    // 背景画像種別装飾切り替え
    $(".baseillust-type-list__item.is-select").removeClass("is-select");
    $("#baseillust-type-list__item-" + baseillustType).addClass("is-select");

    // 背景画像リスト切り替え
    $(".baseillust-container.is-visible").removeClass("is-visible");
    $("#baseillust-container-" + baseillustType).addClass("is-visible");

    // スクロール位置をトップに戻す
    $(".select-base__illust").scrollTop(0);

    // 背景画像選択を解除
    const baseillustId = $("#form_base_illust_id").val();
    if (baseillustId) {
      $(".baseillust.is-selected").removeClass("is-selected");
      //$(".decision-area").removeClass("is-visible").addClass("is-hidden");
      $("#form_base_illust_id").val("");
    }
  }

  /**
   * 保存データ読み込み選択アラートダイアログの表示
   */
  showAlertLoad() {
    const alertLoad = $("#alert-load");
    // アラート表示
    alertLoad.removeClass("is-hidden");
    alertLoad.addClass("is-visible");
  }

  /**
   * 保存データ読み込み選択アラートダイアログでのリスタート実行処理
   */
  restartOnAlertLoad() {
    const alertLoad = $("#alert-load");
    alertLoad.addClass("is-hidden");
    alertLoad.removeClass("is-visible");
  }

  /**
   * 保存データ読み込み選択アラートダイアログでの編集続行実行処理
   */
  continueOnAlertLoad() {
    this.barragePreventAll();
    // +ロード処理を呼び出し側で行うことを想定
  }
}

export default Select;
